"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalTrack = exports.DTrack = void 0;

var triggers = _interopRequireWildcard(require("./components/trigger"));

var actions = _interopRequireWildcard(require("./components/actions"));

var omega = _interopRequireWildcard(require("./components/omega"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class GlobalTrack {
  constructor() {
    this.appKey = '';
    this.uploadHost = '';
    this.omegaKey = '';
    this.Omega = '';
    this.jumpTime = Date.parse(new Date());
    this.appBase = {};
    this.hashChangeFlag = false;
    this.url = '';
    this.element_id = '';
  }

  finTrigger(res) {
    const {
      type,
      params
    } = res;
    if (type === 'pageViewTrigger') actions.pageViewAction.bind(this)(params);
    if (type === 'webClickTrigger') actions.webClickAction.bind(this)(params);
    if (type === 'jumpOutTrigger') actions.jumpOutAction.bind(this)(params);
    if (type === 'moduleViewTrigger') actions.moduleViewAction.bind(this)(params);
  }

  finAction(args) {
    omega.up.bind(this)(args);
  }

  webClick(args) {
    triggers.clickTrigger.bind(this)(args);
  }

  ck(args) {
    this.webClick(args);
  }

  pv(args) {
    actions.pageViewAction.bind(this)(args);
  }

  moduleView(args) {
    triggers.moduleViewTrigger.bind(this)(args);
  }

  sw(args) {
    this.moduleView(args);
  }

  regTrigger() {
    triggers.pageViewTrigger.bind(this)();
    triggers.moduleViewTrigger.bind(this)();
    triggers.jumpOutTrigger.bind(this)();
  }

  regOmega(_ref) {
    let {
      appKey,
      uploadHost,
      omegaKey
    } = _ref;
    omega.init.bind(this)({
      appKey,
      uploadHost,
      omegaKey
    });
  }

  isMobile() {
    return _utils.isMobile;
  }

  init(args) {
    const {
      project_id,
      user_id,
      country,
      city
    } = args;
    this.regOmega(args);
    this.appBase = {
      id: args.omegaKey,
      project_id,
      user_id: user_id !== null && user_id !== void 0 ? user_id : '',
      country,
      city: city !== null && city !== void 0 ? city : '',
      title: (0, _utils.getTitle)(),
      app: (0, _utils.isAndroidOrIos)()
    };
    this.regTrigger();
  }

  setUserId(params) {
    const {
      id
    } = params;
    this.user_id = id !== null && id !== void 0 ? id : '';
    this.appBase.user_id = id !== null && id !== void 0 ? id : '';
  }

}

exports.DTrack = exports.GlobalTrack = GlobalTrack;